import React, { Component, Fragment } from "react";
import CenterElement from "../../activity/activityComponent/CenterElement";

import $ from "jquery";
import "jquery-ui";
import "jquery-ui-dist/jquery-ui";
import ReactDOM from "react-dom";
import DragItem from "../model/DragItem";

class DropItemUI extends Component {
  state = {
    v: "hidden",
  };

  componentDidMount = () => {
    let { quizViewer, dropItem, activity } = this.props;
    let { quizViwerModel } = quizViewer.state;
    $(ReactDOM.findDOMNode(this.itemToDrop)).droppable({
      drop: () => {
        // this.props.activity.currentDragItem=null

        console.log("on drop currentDragItem : ");
        console.log(activity.currentDragItem);
        dropItem.solvedDragItem = new DragItem();
        dropItem.solvedDragItem.initFromJson(
          activity.currentDragItem.getAsJson()
        );

        dropItem.dropTxt =
          dropItem.solvedDragItem.dragViewTxt != "" &&
          dropItem.solvedDragItem.dragViewTxt != undefined
            ? dropItem.solvedDragItem.dragViewTxt
            : dropItem.solvedDragItem.dragTxt;

        console.log("solved dragItem  : ");
        console.log(dropItem.solvedDragItem);

        console.log();
        quizViewer.setState({ quizViwerModel });
      },
    });
    this.extraAction();
  };
  extraAction = () => {};
  render = () => {
    let { dropItem, activity, quizViewer } = this.props;

    let { quizViwerModel } = quizViewer.state;
    let { dragItemList } = activity.dragContainerModel;
    let dropImg = quizViwerModel.imgRes + dropItem.dropImg;

    return <Fragment>{this.getFullDropItem()}</Fragment>;
  };

  getFullDropItem = () => {
    let { dropItem, activity, quizViewer } = this.props;

    let { quizViwerModel } = quizViewer.state;
    let { selectedStyle } = activity.dropItemContainer;
    let dropImg = quizViwerModel.imgRes + dropItem.dropImg;
    return (
      <Fragment>
        <div style={selectedStyle != null ? selectedStyle[1].style : {}}>
          {this.getDropItem()}
          {quizViwerModel.reviewMode ? (
            <div>
              <CenterElement
                content={dropItem.dropTxt}
                style={{
                  fontSize: "26px",
                  color: dropItem.isAnsewredTrue() ? "green" : "red",
                }}
                textAlign="center"
                ref={(el) => (this.itemToDrop = el)}
              />
            </div>
          ) : (
            ""
          )}
        </div>
      </Fragment>
    );
  };

  getDropItem = () => {
    let { dropItem, activity, quizViewer } = this.props;

    let { quizViwerModel } = quizViewer.state;
    let { selectedStyle } = activity.dropItemContainer;
    let dropImg = quizViwerModel.imgRes + dropItem.dropImg;

    return (
      <Fragment>
        <div
        // style={(selectedStyle!=null)?selectedStyle[2].style:{}}
        >
          <img
            style={{ width: "100%" }}
            src={dropImg}
            onClick={this.showImgRes}
          />
        </div>

        <div
        //  style={(selectedStyle!=null)?selectedStyle[3].style:{}}
        >
          <CenterElement
            content={dropItem.dropTxt}
            style={{ fontSize: "26px" }}
            textAlign="center"
            ref={(el) => (this.itemToDrop = el)}
          />
        </div>
      </Fragment>
    );
  };
}

export default DropItemUI;
